import Header from "src/components/layout/Header";
import SelectSiteHeader from "src/components/layout/SelectSiteHeader";
import { CERO_CMS_URL } from "src/shared/config";
import { useDempStore } from "src/context/stores";
import { useRef, useEffect, useState } from "react";


const EarnPointsTransactions = () => {
  const iframeRef = useRef(null);

  const [companyId, plantId] = useDempStore((state) => [state.companyId, state.plantId]);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  // ติดตามเมื่อ iframe โหลดเสร็จ
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      setIsIframeLoaded(true);
    };

    iframe.addEventListener("load", handleLoad);

    return () => {
      iframe.removeEventListener("load", handleLoad);
    };
  }, []);

  // ส่ง postMessage เมื่อ iframe โหลดแล้วและข้อมูลพร้อม
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !isIframeLoaded) return;

    if (companyId && plantId) {
      iframe.contentWindow?.postMessage(
        {
          type: "INITIAL_DATA",
          payload: {
            companyId,
            plantId,
          },
        },
        new URL(CERO_CMS_URL).origin
      );
    }
  }, [isIframeLoaded, companyId, plantId]);

  return (
    <div>
      <Header pageTitle="CERO CMS" showSubMenu={false}>
        <SelectSiteHeader />
      </Header>

      <section className="p-4 bg-white w-full h-[calc(100vh-64px)]">
        <iframe
          ref={iframeRef}
          src={CERO_CMS_URL}
          className="size-full"
          allowFullScreen
        />
      </section>
    </div>
  );
};

export default EarnPointsTransactions;